import { instance } from '../instance'

/**
 *
 * @return {Promise<AxiosResponse<any>>}
 */
export const getCurrencyList = async () => {
  return instance.get('/v1/beneficiary/currency-list')
}
